import galery1 from '../img/galeria-1.jpg';
import galery2 from '../img/galeria-2.jpg';
import galery3 from '../img/galeria-3.jpg';
import galery4 from '../img/galeria-4.jpg';
import galery5 from '../img/galeria-5.jpg';
import galery6 from '../img/galeria-6.jpg';
import galery7 from '../img/galeria-7.jpg';
import galery8 from '../img/galeria-8.jpg';
import galery9 from '../img/galeria-9.jpg';

export const images = {
  1: galery1,
  2: galery2,
  3: galery3,
  4: galery4,
  5: galery5,
  6: galery6,
  7: galery7,
  8: galery8,
  9: galery9,
};
